import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ModalName } from "src/app/enums/modal-name";
import { IFax } from "src/app/models/fax/fax";
import { ISendTelnyxFaxSearchParams } from "src/app/models/telnyx/send-telnyx-fax-search-params";
import { FaxService } from "src/app/services/fax.service";
import { ModalService } from "src/app/services/modal.service";
import { TelnyxService } from "src/app/services/telnyx.service";

@Component({
  selector: "app-fax",
  templateUrl: "./fax.component.html",
  styleUrls: ["./fax.component.scss"],
})
export class FaxComponent implements OnInit {
  fax: IFax | null = null;
  faxFileSrc = "";
  faxFilePage = 1;
  isInfoModalOpen = false;
  isZoomModalOpen = false;
  faxToResend: IFax | null = null;

  constructor(
    private readonly _faxService: FaxService,
    private readonly _telnyxService: TelnyxService,
    private readonly _modalService: ModalService,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _location: Location
  ) {}

  selectFaxFilePage(faxFilePage: number) {
    this.faxFilePage = faxFilePage;
  }

  formatFaxDate(dateTime?: string) {
    if (!dateTime) {
      return "";
    }

    const date = new Date(dateTime);

    const datePart = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    const timePart = date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

    return `${datePart} ${timePart}`;
  }

  openDeleteConfirmationPopup() {
    this._modalService.openModal(ModalName.DeleteFax);
  }

  openEmailModal() {
    if (this.fax === null) {
      return;
    }

    this.faxToResend = { ...this.fax };
  }

  onResendModalSubmit() {
    this.getFax();
  }

  deleteFax() {
    if (this.fax === null) {
      return;
    }

    this._faxService.delete(this.fax.id.toString()).subscribe({
      next: () => {
        this._location.back();
      },
    });
  }

  async sendFax() {
    if (this.fax === null) {
      return;
    }

    const sendFaxSearchParams: ISendTelnyxFaxSearchParams = {
      sendCopies: "false",
      generateEmailBody: "false",
      toEmail: "",
      toNumber: this.fax.toNumber,
      fromNumber: this.fax.fromNumber,
      deliveryTo: this.fax.toName ?? "",
      sentFrom: this.fax.fromName ?? "",
      faxSubject: this.fax.subject ?? "",
      notes: this.fax.notes ?? "",
      folderName: "",
    };

    try {
      const faxFile = await fetch(this.faxFileSrc).then(response => response.blob());
      const faxPdf = new File([faxFile], "fax.pdf", { type: "application/pdf" });

      this._telnyxService.sendFax(sendFaxSearchParams, faxPdf).subscribe({
        next: () => {
          this.getFax();
        },
      });
    } catch (error) {
      console.error("Error resending fax:", error);
    }
  }

  ngOnInit() {
    this.getFax();
  }

  private getFax() {
    const faxId = this._activatedRoute.snapshot.paramMap.get("id");

    if (faxId) {
      this._faxService.getOne(faxId).subscribe(fax => {
        this.fax = fax;
        this.getFileSrc();
      });
    }
  }

  private getFileSrc() {
    const faxId = this.fax?.id?.toString?.();

    if (faxId && this.fax?.file) {
      this._faxService.getFileSrc(faxId).subscribe({
        next: faxFileSrc => {
          this.faxFileSrc = faxFileSrc;
        },
        error: error => {
          console.error("Failed to load fax file:", error?.message ?? error);
        },
      });
    }
  }
}
